<PageHeader>
	<div class="row c">
		<Breadcrumbs :items="[{title:'Редактор новостей категории опроса'}]"/>
	</div>
</PageHeader>

<PageTitle :title="`Редактор новостей`"/>

<NewsGrid :id="id"></NewsGrid>